import { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import getXcolumnJson from "./xcolumn/list";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup_portal';
import FindStudyPopup from "@/pages/comp/plan/todo/popup/find_study";
import FindVideoPopup from "@/pages/comp/plan/todo/popup/find_video";
import FindCGWordPopup from "@/pages/comp/plan/todo/popup/find_cg_word";
import strFunc from '@/lib/lyg/string';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import DefaultContentArea from "./area/default_area";

const TodoContetnArea = forwardRef((props: any, ref) => {
  const myProps = {
    is_use_online_textbook: false,
    set_todo_content_arr: (inOptObj: any) => { },
    ...props
  };

  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  let user = useSelector((state: any) => state.user);

  const [todo_content_arr, set_todo_content_arr] = useState<any>([]);
  let storage_default_data: any = strFunc.get_storage("make_todo_default_todo_content", "{}");
  if (storage_default_data) {
    storage_default_data = JSON.parse(storage_default_data);
    storage_default_data = {
      a_sort: storage_default_data.a_sort || "homework",//homework 숙제, study 학습, video 강의
      a_subject: storage_default_data.a_subject || "수학",
    };
  }
  const [default_todo_content, set_default_todo_content] = useState<any>({
    "a_seq": 1,
    "a_sort": "homework",//homework 숙제, study 학습, video 강의
    "a_sort_det": "",
    "a_subject": "수학",
    "a_title": "",
    "a_content": "",
    "a_success_sort": "amount",//amount,time
    "a_par_id": "",
    "a_par_seq": "",
    "a_success_amount": "0",
    "a_success_time_sec": "0",
    "a_amount_sort": "",
    "row_view_success_amount": "1",
    ...storage_default_data
  });
  const [all_change_data, set_all_change_data] = useState<any>({
    "row_view_success_amount": 0,
    "a_amount_sort": "",
  });
  const [is_use_online_textbook, set_is_use_online_textbook] = useState<boolean>(myProps.is_use_online_textbook);
  let select_subject_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  xColumnArr.select_arr["a_subject"] = select_subject_option_arr;
  
  for(let i=0;i<xColumnArr.x_column_list_arr.length;i++){
    let tmp_col=xColumnArr.x_column_list_arr[i];
    if(tmp_col.key=="row_view_success_amount_start"){
      if(myProps.is_use_online_textbook){
        xColumnArr.x_column_list_arr[i].is_show="1";
      }
    }
  }

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "find_study",//find_study,find_video,find_textbook
    title: "교재찾기",
    s_use_sort: "study",//procedure
    listOpt: {},
    width: "1000px",
    height: "100%",
  });

  const setInitData = (inOptObj: any) => {
    if (inOptObj == undefined) {
      inOptObj = {};
    }
    let optObj = {
      "todo_content_arr": [],
      ...inOptObj
    };
    set_todo_content_arr(optObj.todo_content_arr);
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData, get_todo_content_arr, set_is_use_online_textbook
  }));

  const get_todo_content_arr = () => {
    let all_row = ListComponentRef.current.getRows();
    set_todo_content_arr(all_row);
    return all_row;
  };

  const openFindStudyPopup = (inData: any) => {
    let opt_obj = {
      s_use_sort: "study",
      ...inData
    };
    let popup_title = "교재찾기";
    if (opt_obj.s_use_sort == "procedure") {
      popup_title = "학습절차";
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "find_study",
      title: popup_title,
      s_use_sort: opt_obj.s_use_sort,
    });
  };
  const openFindVideoPopup = () => {
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "find_video",
      title: "동영상강의 찾기",
    });
  };

  const add_custom_todo = () => {
    let all_row = ListComponentRef.current.getRows();
    let last_seq = get_last_seq();
    let add_row_data = {
      ...default_todo_content,
      "a_seq": last_seq,
      "a_success_sort": "amount",
    };
    all_row.push(add_row_data);
    ListComponentRef.current.setInfoArr(all_row);
  };

  const add_study_list_by_callback = (inData: any) => {
    let opt_obj = {
      "info_arr": [],
      ...inData
    };

    let all_row = ListComponentRef.current.getRows();
    let last_seq = get_last_seq();
    last_seq++;

    for (let i = 0; i < opt_obj["info_arr"].length; i++) {
      let study_info = opt_obj["info_arr"][i];
      if (strFunc.is_empty(study_info["a_amount_num"])) {
        study_info["a_amount_num"] = "1";
      }
      let add_row_data = {
        ...default_todo_content,
        "a_seq": last_seq,
        // "a_sort": "study",
        "a_subject": study_info["a_subject_sort"],
        "a_title": study_info["a_title"],
        "a_content": study_info["a_content"],
        "a_success_sort": "amount",
        "a_par_id": "study_list",
        "a_par_seq": study_info["a_title_seq"] + "," + study_info["a_seq"],
        "a_success_amount": study_info["a_amount_num"],
        "a_amount_sort": study_info["a_amount_sort"],
        "row_view_success_amount_start":0,
        "row_view_success_amount": study_info["a_amount_num"],
        "a_add_file_type": study_info["a_add_file_type"],
      };

      all_row.push(add_row_data);
    }
    ListComponentRef.current.setInfoArr(all_row);
  };

  const add_video_list_by_callback = (inData: any) => {
    let opt_obj = {
      "info_arr": [],
      ...inData
    };

    let all_row = ListComponentRef.current.getRows();
    let last_seq = get_last_seq();
    last_seq++;

    for (let i = 0; i < opt_obj["info_arr"].length; i++) {
      let video_info = opt_obj["info_arr"][i];
      let a_total_sec = strFunc.uncomma(video_info["a_total_sec"]);
      let add_row_data = {
        ...default_todo_content,
        "a_seq": last_seq,
        // "a_sort": "study",
        "a_subject": video_info["a_subject"],
        "a_title": video_info["a_title"],
        "a_content": video_info["a_content"],
        "a_success_sort": "amount",
        "a_par_id": "video_list",
        "a_par_seq": video_info["a_mcomp_seq"]+","+video_info["a_corse_seq"] + "," + video_info["a_seq"],
        "a_success_time_sec": a_total_sec,
        "a_success_amount": "1",
        "a_amount_sort": "개",
        "row_view_success_amount": "1"
      };
      all_row.push(add_row_data);
    }
    ListComponentRef.current.setInfoArr(all_row);
  };

  const get_last_seq = () => {
    let last_seq = 0;
    let all_row = ListComponentRef.current.getRows();
    for (let i = 0; i < all_row.length; i++) {
      let tmp_row = all_row[i];
      let tmp_seq = parseInt(tmp_row.a_seq);
      if (tmp_seq > last_seq) {
        last_seq = tmp_seq;
      }
    }
    return last_seq;
  };

  const removeSelect = () => {
    let all_row = ListComponentRef.current.getRows();
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length == 0) {
      return false;
    }
    let remain_row_arr = [];
    for (let i = 0; i < all_row.length; i++) {
      let tmp_row = all_row[i];
      let tmp_is_exist = false;
      for (let j = 0; j < selected_row.length; j++) {
        let tmp_sel_row = selected_row[j];
        if (tmp_row.a_seq == tmp_sel_row.a_seq) {
          tmp_is_exist = true;
        }
      }
      if (tmp_is_exist == false) {
        remain_row_arr.push(tmp_row);
      }
    }
    ListComponentRef.current.setInfoArr(remain_row_arr);
  };

  const removeOneRow = (idx: number) => {
    let new_info_arr = [];
    let all_row = ListComponentRef.current.getRows();
    for (let i = 0; i < all_row.length; i++) {
      if (i == idx) {

      } else {
        new_info_arr.push(all_row[i]);
      }
    }
    ListComponentRef.current.setInfoArr(new_info_arr);
  };

  const on_change_all_change_data = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      ...inData
    };
    let name = opt_obj.name;
    let value = opt_obj.value;
    let new_all_change_data = { ...all_change_data };
    new_all_change_data[name] = value;
    set_all_change_data(new_all_change_data);

    let all_row = ListComponentRef.current.getRows();
    let change_todo_content_arr = [...all_row];
    for (let i = 0; i < change_todo_content_arr.length; i++) {
      let tmp_row = change_todo_content_arr[i];
      if (name == "row_view_success_amount") {
        tmp_row["row_view_success_amount"] = value;
      } else if (name == "a_amount_sort") {
        tmp_row["a_amount_sort"] = value;
      }
      change_todo_content_arr[i] = tmp_row;
    }
    ListComponentRef.current.setInfoArr(change_todo_content_arr);
  };

  const open_find_textbook_popup = (inData: any) => {
    let opt_obj = {
      par_sort: "mtextbook",//word_inside
      ...inData
    };

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "find_cg_word",
      title: "온라인학습단어",
      par_sort: opt_obj.par_sort,
      listOpt: {
        s_subject:default_todo_content.a_subject,
        s_is_able_order: "empty",
        s_addon_study_word: "1",
        s_use_sort: "study_word",
      },
    });
  };

  const callback_find_textbook = (inData: any) => {
    let opt_obj = {
      "info_arr": [],
      ...inData
    };

    let all_row = ListComponentRef.current.getRows();
    let last_seq = get_last_seq();
    last_seq++;

    for (let i = 0; i < opt_obj["info_arr"].length; i++) {
      let row_info = opt_obj["info_arr"][i];
      let row_word_cnt = 0;
      let row_cg_word_arr: any = [];
      if (row_info.study_arr) {
        for (let s_i = 0; s_i < row_info.study_arr.length; s_i++) {
          let study_row = row_info.study_arr[s_i];
          if (study_row.cg_word_arr) {
            row_word_cnt += study_row.cg_word_arr.length;
            row_cg_word_arr = [
              ...row_cg_word_arr,
              ...study_row.cg_word_arr
            ];
          }
        }
      }

      if (row_info.cg_word_arr) {
        row_word_cnt += row_info.cg_word_arr.length;
        row_cg_word_arr = [
          ...row_cg_word_arr,
          ...row_info.cg_word_arr
        ];
      }
      let row_subject = "";
      let row_par_id = popupData.par_sort;
      let row_par_seq = row_info["a_seq"];
      if (row_par_id == "mtextbook") {
        row_subject = row_info["a_subject"];
      } else if (row_par_id == "word_inside") {
        row_subject = "영어";
      }

      let add_row_data: any = {
        ...default_todo_content,
        "a_seq": last_seq,
        // "a_sort": "study",
        "a_sort_det": "cg_word",
        "a_subject": row_subject,
        "a_title": row_info["a_title"],
        "a_content": "",
        "a_success_sort": "amount",
        "a_par_id": row_par_id,
        "a_par_seq": row_par_seq,
        "a_success_time_sec": 0,
        "a_success_amount": row_word_cnt,
        "a_amount_sort": "개",
        "row_view_success_amount": row_word_cnt,
        "cg_word_arr": row_cg_word_arr
      };
      all_row.push(add_row_data);
    }
    ListComponentRef.current.setInfoArr(all_row);
  };

  const customThCellRenderer = (params: any) => {
    /*
    {
      "key":key,
      "name":name,
      "head_str":head_str,
    }
    */
    let key = params.key;
    let head_str = params.head_str;
    if (key == "row_view_success_amount") {
      head_str = (
        <div className="text-center">
          <span>총 학습량</span>
          <input type="text" className="ml-1 row-input" name="row_view_success_amount"
            onChange={(e: any) => {
              on_change_all_change_data({ name: e.target.name, value: e.target.value });
            }} style={{ width: "50px" }} />
        </div>
      );
    } else if (key == "a_amount_sort") {
      head_str = (
        <div className="text-center">
          <span>단위</span>
          <input type="text" className="ml-1 row-input" name="a_amount_sort"
            onChange={(e: any) => {
              on_change_all_change_data({ name: e.target.name, value: e.target.value });
            }} style={{ width: "50px" }} />
        </div>
      );
    }
    return head_str;
  };

  const customCellRenderer = (params: any) => {
    /*
      {
        "rowData":rowData,
        "idx":idx,
        "key":key,
        "value":row_val
      }
      */
    let key = params.key;
    let val_str = params.value;

    if (key == "a_sort") {
      if (xColumnArr.select_arr[key]) {
        for (let i = 0; i < xColumnArr.select_arr[key].length; i++) {
          let sel_opt_row = xColumnArr.select_arr[key][i];
          if (sel_opt_row["value"] == val_str) {
            val_str = sel_opt_row["text"];
          }
        }
      }
    } else if (key == "a_success_sort") {
      if (xColumnArr.select_arr[key]) {
        for (let i = 0; i < xColumnArr.select_arr[key].length; i++) {
          let sel_opt_row = xColumnArr.select_arr[key][i];
          if (sel_opt_row["value"] == val_str) {
            val_str = sel_opt_row["text"];
          }
        }
      }
    } else if (key == "row_view_manage") {
      val_str = (
        <div className="text-center">
          <button className="btn btn-red" onClick={() => {
            removeOneRow(params.idx);
          }}>삭제</button>
        </div>
      );
    } else if (key == "row_view_sort_subject") {
      let renter_str = "학습";
      if (params.rowData.a_sort == "homework") {
        renter_str = "숙제";
      }
      renter_str = params.rowData.a_subject + " " + renter_str;
      val_str = renter_str;
    }

    return val_str;
  };
  const customGridCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "input_tag":input_tag,
      "onChangeInput":onChangeInput,
    }
    */
    let key = params.key;
    if (key == "row_view_success_amount") {

    } else if (key == "a_amount_sort") {
      if (params.rowData.a_success_sort == "time") {
        params.input_tag = "분";
      }
    }
    return params.input_tag;
  };

  return (
    <div>
      <div className="my-1 text-right" style={{ position: "relative" }}>
        <span style={{ position: "absolute", left: "0", top: "0" }}>
          <DefaultContentArea
            default_todo_content={default_todo_content}
            set_default_todo_content={set_default_todo_content}
            select_subject_option_arr={select_subject_option_arr}
            add_custom_todo={add_custom_todo}
          ></DefaultContentArea>
        </span>
        <button className="btn-m btn-yellowish3 ml-1" onClick={() => { add_custom_todo(); }} >직접입력</button>
        {is_use_online_textbook &&
          <>
            <button className="btn-m btn-yellowish3 ml-1" onClick={() => { open_find_textbook_popup({}); }} >단어학습</button>
            <button className="btn-m btn-yellowish3 ml-1" onClick={() => { open_find_textbook_popup({ par_sort: "word_inside" }); }} >단어학습(in)</button>
          </>
        }
        <button className="btn-m btn-yellowish3 ml-1" onClick={() => { openFindStudyPopup({ s_use_sort: "study" }); }} >교재찾기</button>
        <button className="btn-m btn-yellowish3 ml-1" onClick={() => { openFindStudyPopup({ s_use_sort: "procedure" }); }} >학습절차</button>
        <button className="btn-m btn-yellowish3 ml-1" onClick={() => { openFindVideoPopup(); }} >강의찾기</button>
        <button className="btn-m btn-red ml-1" onClick={() => { removeSelect(); }} >삭제</button>
      </div>
      <ListComponent
        ref={ListComponentRef}
        xColumnArr={xColumnArr}
        infoArr={todo_content_arr}
        gridOpt={{
          isGrid: true,
          is_add_idx_num: false,
          is_add_checkbox: true,
          width: "100%",
          height: "45vh",
          is_auto_max_width: false,
          td_align: "left",//center,right
          table_align: "left",//center,right
          onGridReady: () => { },
          rowOnClick: (rowData: any, idx: number, e: any) => {

          },
          customCellRenderer: customCellRenderer,
          customGridCellRenderer: customGridCellRenderer,
          customThCellRenderer: customThCellRenderer,
          class_name_json: {
            table_div: "basic_list_div",
            td_div: "row-col-div",
            input_check: "chk_row",
            row_input: "row-input",
            data_row_tr: "data_row_tr",
            active_row: "active",
            empty_con_div: "list_empty_content_div",
          },
        }}
      ></ListComponent>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} y={"0"} >
          {popupData.sort === "find_study" &&
            <FindStudyPopup
              listOpt={{
                "s_subject_sort": default_todo_content.a_subject,
                "s_use_sort": popupData.s_use_sort
              }}
              callbackData={add_study_list_by_callback}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindStudyPopup>
          }
          {popupData.sort === "find_video" &&
            <FindVideoPopup
              listOpt={{
                "s_subject": default_todo_content.a_subject,
              }}
              callbackData={add_video_list_by_callback}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindVideoPopup>
          }
          {popupData.sort === "find_cg_word" &&
            <FindCGWordPopup
              par_sort={popupData.par_sort}
              listOpt={popupData.listOpt}
              is_req_order={false}
              xcolumn_show_key_arr={["row_view_word_count"]}
              callbackData={callback_find_textbook}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindCGWordPopup>
          }
        </LayerPopup>
      }
    </div>
  );
});

export default TodoContetnArea;
